import { ColorTypes } from '@genial/design-tokens';

import { FilterModalTypes } from '../../../../../../../../components/FilterModal';
import { TableHeadItemRecurse } from '../../../../../../../../components/TableHead';
import { emptyMarketStatusQuery } from '../../../../../../../../store/product/selectors';
import { DynamicCustomFiltersProps } from '../../../../../../../../store/product/types';
import { AssetCaptionType } from '../../../../../../../BatchTicket/components/DynamicAsset/components/AssetCaptions';
import {
  legacyInitialApplicationFilter,
  privatePensionSettlementPeriodFilter,
} from '../../../../../../../BatchTicket/components/DynamicAsset/components/AssetFilters/constants';
import {
  transformCustomCategories,
  transformCustomFilters,
} from '../../../../../../../BatchTicket/components/DynamicAsset/constants';

import { PrivatePensionProduct } from '.';

export const privatePensionTableHead: TableHeadItemRecurse[] = [
  { title: '', flex: 0.5 },
  { title: 'Fundo', orderValue: 'productNameNormalized', flex: 2 },
  { title: 'Tipo', orderValue: 'productTypeNormalized' },
  { title: 'Mês', orderValue: 'monthlyRentabilityNormalized' },
  { title: 'Ano', orderValue: 'annualRentabilityNormalized' },
  { title: '12 Meses', orderValue: 'twelveMonthsRentabilityNormalized' },
  { title: 'Aplic. Min', orderValue: 'minimumApplicationNormalized' },
  { title: 'Data início', orderValue: 'initialDateTime' },
  { title: 'Data de referência', orderValue: 'referenceDateTime' },
];

export const availableProductPrivatePensionConstant = {
  id: 'privatePension',
  title: 'Previdência',
  color: 'product.previdencia' as ColorTypes.Option,
  principalComponent: PrivatePensionProduct,
  marketStatusSelector: emptyMarketStatusQuery,
  tableHead: privatePensionTableHead,
  hideTableHead: false,
  hasFilters: true,
  mountFilters: (customFilters: DynamicCustomFiltersProps): FilterModalTypes.FilterType[] => {
    return [
      ...transformCustomFilters(customFilters, 1),
      legacyInitialApplicationFilter,
      privatePensionSettlementPeriodFilter,
    ];
  },
  hasCategories: true,
  categoriesLabel: 'Categorias',
  categoriesField: 'subCategories',
  mountCategories: (customFilters: DynamicCustomFiltersProps) =>
    transformCustomCategories(customFilters, 'subCategories'),
  captions: [] as AssetCaptionType[],
  hasRefresher: false,
} as const;
